<template>
  <div class="welcome">
    <img src="@/assets/img/99icon_black.svg" class="welcome__logo" alt="99 Empresas" >

    <v-container fill-height :style="`min-height: ${windowHeight}px`">
      <v-layout align-center justify-center row wrap>
        <v-flex md6 sm12 xs12>
          <h1 class="welcome__title">{{ $t(`${namespace}.title`) }}</h1>
          <h2 class="welcome__subtitle">{{ $t(`${namespace}.subtitle`) }}</h2>
          <p class="welcome__text">{{ $t(`${namespace}.paragraph`) }}</p>
          <p class="welcome__text">
            <strong>{{ $t(`${namespace}.letsStart`) }}</strong>
          </p>

          <div class="welcome__actions">
            <v-btn
              :to="{ name: 'CostCenter', params: { type: 'cadastrar' } }"
              color="warning--gradient"
              class="mx-0"
              round
              depressed
              large
            >
              {{ $t(`${namespace}.buttonLabel`) }}
            </v-btn>

            <div class="mt-2">
              <a
                href="#"
                class="accent--text"
                :title="$t(`${namespace}.skip`)"
                @click.prevent="skip"
              >
                {{ $t(`${namespace}.skip`) }}
              </a>
            </div>
          </div>

          <v-checkbox v-model="disabled" :label="$t(`${namespace}.checkbox`)" />
        </v-flex>

        <v-flex md6 sm12 xs12>
          <img class="welcome__img" src="@/assets/img/illutr-main.svg" alt="">
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { SESSION_WELCOME } from 'utils/constants'

export default {
  name: 'Welcome',
  data () {
    return {
      namespace: 'Views.Welcome',
      windowHeight: 0,
      disabled: false
    }
  },
  methods: {
    calcWindowHeight () {
      this.windowHeight = window.innerWidth >= 960
        ? window.innerHeight - 135
        : 0
    },

    skip () {
      this.$router.push('/')
    },

    toggleWelcomeStoreItem (val) {
      val
        ? localStorage.setItem(SESSION_WELCOME, val)
        : localStorage.removeItem(SESSION_WELCOME)
    }
  },
  watch: {
    disabled (val) {
      this.toggleWelcomeStoreItem(val)
    }
  },
  mounted () {
    this.calcWindowHeight()
    window.addEventListener('resize', this.calcWindowHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcWindowHeight)
  }
}
</script>

<style lang="scss">
.route--welcome.theme--light.application {

  .application--wrap {
    background-color: #f6f5f6;
  }
}
</style>

<style lang="scss" scoped>
.welcome {
  max-width: 880px;
  margin: 0 auto;
  padding: 96px 16px 32px;
  position: relative;

  @media (min-width: 960px) {
    padding-top: 32px;
  }
}

.welcome__logo {
  left: 50%;
  position: fixed;
  top: 30px;
  margin-left: -32px;
  z-index: 4;
}

.welcome__title,
.welcome__subtitle {
  font-family: 'Montserrat', sans-serif;
}

.welcome__title {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.3;
}

.welcome__subtitle {
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.welcome__text {
  color: $gray-6;

  strong {
    color: $gray-7;
  }
}

.welcome__actions {
  display: inline-block;
  text-align: center;
}

.welcome__img {
  display: block;
  margin: 40px auto 0;
  max-width: 80%;

  @media (min-width: 960px) {
    float: right;
    margin-top: 0;
    max-width: 100%;
  }
}
</style>
